if (!window.Eurus.loadedScript.has('locales-form.js')) {
  window.Eurus.loadedScript.add('locales-form.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xLocalizationForm', () => ({ 
        openCountry: false,
        loading: false,
        cachedResults: false,
        submit(value, input) {
          this.$el.closest("#localization_form").querySelector('#'+input).value = value;
          this.$el.closest("#localization_form").submit();
        },
        loadCountry(el) {
          if (this.cachedResults) {
            this.openCountry = true;
            return true
          }
          let countrySelector = el.closest(".country-selector");
          let optionEL = countrySelector.querySelector(".country-options");

          this.loading = true;
          fetch(window.Shopify.routes.root + '?section_id=country-selector')
          .then(reponse => {
            return reponse.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const content = parser.parseFromString(response,'text/html').getElementById("list-country").innerHTML;
            optionEL.innerHTML = content;
            this.cachedResults = true;
            this.openCountry = true;
          })
          .finally(() => {
            this.loading = false;
          })
        },
      }))

      /**
       * Sprachwaehler auf Weglot statt auf Shopify-Locales.
       *
       * Der Shopify-Wechsler (POST /localization) fuehrt auf /en, /fr usw., wo
       * Weglot nicht anspringt - dort liegt nur der alte, unvollstaendige
       * Uebersetzungsbestand. Weglot uebersetzt stattdessen im Browser auf
       * derselben URL. Diese Komponente haengt den Klick auf Weglot um und
       * nimmt die Sprachliste von dort, damit Wechsler und Uebersetzer nicht
       * auseinanderlaufen.
       *
       * Faellt Weglot aus, bleibt das alte Shopify-Verhalten als Fallback.
       *
       * @param {string} shopifyLocale Aktuelles Shopify-Locale, z.B. "de"
       * @param {string} shopifyLabel  Anzeigename dazu, z.B. "Deutsch"
       */
      Alpine.data('xWeglotLocale', (shopifyLocale, shopifyLabel) => ({
        open: false,
        current: shopifyLocale,
        label: shopifyLabel,
        // null = Weglot noch nicht bekannt -> alle Sprachen zeigen, nicht keine
        langs: null,

        init() {
          this.sync();
          this.watchWeglot();
        },

        watchWeglot() {
          if (this.bind()) return;

          // ponytail: Weglot laedt als externes Script und bietet vor dem Laden
          // keinen Hook an - darum kurzes Polling. Bei einem Weglot-Update mit
          // eigenem Ready-Event kann das hier entfallen.
          let tries = 0;
          const poll = setInterval(() => {
            if (this.bind() || ++tries > 20) clearInterval(poll);
          }, 250);
        },

        /** @returns {boolean} true, sobald die Weglot-Events haengen */
        bind() {
          const wg = window.Weglot;
          if (!wg || typeof wg.on !== 'function') return false;

          wg.on('initialized', () => this.sync());
          wg.on('languageChanged', () => this.sync());
          this.sync();
          return true;
        },

        /** Uebernimmt Sprachliste, aktuelle Sprache und Label von Weglot. */
        sync() {
          const wg = window.Weglot;
          if (!wg || !wg.initialized) return;

          const options = wg.options || {};
          const targets = (options.languages || [])
            .filter((entry) => entry.enabled !== false)
            .map((entry) => entry.language_to);
          const origin = options.language_from;

          this.langs = origin ? [origin].concat(targets) : targets;

          const active = wg.getCurrentLang();
          if (!active) return;

          this.current = active;
          this.label = this.nameFor(active) || this.label;
          this.applyDirection(active);
        },

        /**
         * Anzeigename einer Sprache, aus dem gerenderten Markup gelesen.
         * @param {string} iso
         * @returns {string|null}
         */
        nameFor(iso) {
          const link = this.$root.querySelector('[data-locale="' + iso + '"]');
          return link ? link.dataset.localeName : null;
        },

        /**
         * Zeigt einen Eintrag nur, wenn Weglot die Sprache auch liefert.
         * @param {string} iso
         * @returns {boolean}
         */
        offers(iso) {
          return this.langs === null || this.langs.indexOf(iso) !== -1;
        },

        /**
         * Weglot setzt die Textrichtung nicht - das Theme hat die rtl:-Klassen,
         * sie brauchen nur das dir-Attribut.
         * @param {string} iso
         */
        applyDirection(iso) {
          const isRtl = ['ar', 'he', 'fa', 'ur'].indexOf(iso) !== -1;
          document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
        },

        /** @param {string} iso Ziel-Sprache */
        switchLang(iso) {
          this.open = false;
          const wg = window.Weglot;

          if (wg && wg.initialized && typeof wg.switchTo === 'function') {
            this.current = iso;
            this.label = this.nameFor(iso) || this.label;
            this.applyDirection(iso);
            wg.switchTo(iso);
            return;
          }

          // Fallback ohne Weglot: Shopify-Locale wie vor dem Umbau
          const form = this.$el.closest('#localization_form');
          if (!form) return;

          const input = form.querySelector('#locale_selector');
          if (input) input.value = iso;
          form.submit();
        },
      }))
    });
  });
}